import React, { useCallback, useEffect, useRef, useState } from 'react';
import './index.less';
import MessageHeader from '@/components/MessageComponent/MessageHeader';

import { LeftOutlined } from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import { getMessageDetail } from '@/api/messageCenter';
import { message, Spin } from 'antd';
import {  MessageDataType, MessageDetailType } from '@/types/message';
import Logo from "@/assets/images/message/logo.png";
import WxCode from "@/assets/images/message/qrcode.png"
import { downloadBtnIds, getDownloadBtn } from './download';
const prefix = 'message-detail';



const MessageDetail: React.FC = () => {
  const location=useLocation();
  const navigate=useNavigate();
  const messageId=useRef<any>("");
  const selectType=useRef<any>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [messageInfo, setMessage] =useState<MessageDataType>();
  /**
   * 返回按钮
   */
  const arrowIcon=<div className={`message-back-arrow`} onClick={() => navigate('/message/list?type='+selectType.current)}>
  <LeftOutlined />
  返回
</div>
  /**
   * 消息内容结构
   */
  const messageInfoStruct=useCallback(()=>{
    return <div className='message-info-struct'>
      <div className='message-info-struct-top'>
        <img className='message-info-logo' src={Logo} alt="深开鸿" />
        <div className="message-info-box">
        <Spin  spinning={loading} size='large'>
          <div className="message-info-content">
            <div className="common-message-header">{messageInfo?.title}</div>
            <div className='message-box' dangerouslySetInnerHTML={{
              __html: messageInfo?.isEncodeUri ? decodeURIComponent(messageInfo?.content ||""): messageInfo?.content
            }
            }>
              
            </div>
          </div>
          
        </Spin>
        </div>
      </div>
      
      <div className="message-info-bottom-logo">
        <img src={WxCode} alt="深开鸿微信公众号" />
        <div>以数字化、智慧化改变人类的生产和生活方式</div>
        <a href="http://www.kaihong.com" rel='noopener noreferrer' target='_blank'>www.kaihong.com</a>
      </div>
    </div>
    
  },[messageInfo, loading])
  
  /**
   * 获取消息详情
   */
  const getMessageData=()=>{
    getMessageDetail({id: messageId.current}).then((res:MessageDetailType)=>{
      setLoading(false);
      try {
        if(res?.code===200){
          console.log('getMessageData',res);
          setMessage(res?.result);
        }else{
          window.message.error(res?.message)
        }
      } catch (error) {
        console.error(error);
      }
    }).catch((err)=>{
      console.error(err);
      setLoading(false);
      window.message.error('请求失败')
    })
  }

  /**
   *  为消息详情中的 指定id的下载按钮添加点击事件
   */
  useEffect(()=>{
    console.log('messgae info ');
    if(messageInfo&& messageInfo?.signTaskId){
      console.log('messgae info ',messageInfo);
      getDownloadBtn(messageInfo?.signTaskId);
    }
    
  },[messageInfo])
  useEffect(()=>{
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');
    const type=searchParams.get('type');
    selectType.current=type;
    messageId.current=id;
    getMessageData();
  },[])
  return (
    <div className={`${prefix} message-contain-layout`}>
      <MessageHeader title={messageInfo?.title} des={messageInfo?.createTime} LeftSolt={arrowIcon} />
      <div className={`${prefix}-content`}>
        <div className={`${prefix}-content-box`}>
          {messageInfoStruct()}
        </div>
      </div>
    </div>
  );
};

export default MessageDetail;
